module.exports = __webpack_public_path__ + "static/media/data-collection.dd0e6d54.png";